import { type ColorName } from '@/theme/type'
import { colorNameToHex } from '@/utils/color'
import styled from '@emotion/styled'

interface DividerProps {
  color?: ColorName
  margin?: string
  width?: string | number
  direction?: 'horizontal' | 'vertical'
}

/**
 *
 * @param width 가로 또는 세로 너비
 */
const Divider = ({
  color = 'fillNormal',
  margin = '0',
  width = '100%',
  direction = 'horizontal',
}: DividerProps) => {
  const length = typeof width === 'number' ? `${width}px` : width
  return <StyledDivider color={color} margin={margin} width={length} direction={direction} />
}

export default Divider

const StyledDivider = styled.hr<DividerProps>`
  width: ${({ direction, width }) => (direction === 'horizontal' ? width : '1px')};
  height: ${({ direction, width }) => (direction === 'horizontal' ? '1px' : width)};
  background-color: ${({ color }) => colorNameToHex(color ?? 'fillNormal')};
  margin: ${({ margin }) => margin};
`
